import Card from "components/card";
import Switch from "components/switch";

export default function SectionCard({
  title,
  description,
  hide,
  onHideChange,
  hideId,
  onSave,
  saving,
  canSave = false,
  children,
}) {
  const switchId = hideId || `${title}-hide`;

  return (
    <Card extra="mb-3 overflow-visible rounded-2xl border border-gray-200 shadow-none dark:!border-white/10">
      <div className="sticky top-[4.75rem] z-20 flex flex-wrap items-center justify-between gap-2 rounded-t-2xl border-b border-purple-100 bg-gradient-to-r from-[#F3F0FF] to-white px-3.5 py-2.5 shadow-[0_10px_18px_-12px_rgba(76,63,232,0.35)] dark:border-white/10 dark:from-navy-800 dark:to-navy-800">
        <div className="flex min-w-0 items-center gap-2.5">
          <span className="h-7 w-1 shrink-0 rounded-full bg-gradient-to-b from-[#4C3FE8] to-[#A855F7]" />
          <div className="min-w-0">
            <h3 className="text-base font-bold text-navy-700 dark:text-white">
              {title}
            </h3>
            {description ? (
              <p className="text-xs text-gray-500">{description}</p>
            ) : null}
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-3">
          {onHideChange ? (
            <label
              htmlFor={switchId}
              className="flex cursor-pointer items-center gap-1.5"
              title="Turn on to hide this section on the website"
            >
              <span className="text-xs font-medium text-navy-700 dark:text-white">
                Hide
              </span>
              <Switch
                id={switchId}
                checked={!!hide}
                onChange={(event) => onHideChange(event.target.checked)}
              />
            </label>
          ) : null}
          {onSave ? (
            <button
              type="button"
              onClick={onSave}
              disabled={saving || !canSave}
              className="linear rounded-lg bg-gradient-to-r from-[#4C3FE8] to-[#A855F7] px-3.5 py-1.5 text-xs font-medium text-white transition duration-200 hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-40"
            >
              {saving ? "Saving…" : "Save"}
            </button>
          ) : null}
        </div>
      </div>
      <div className="flex flex-col gap-3 p-3.5">{children}</div>
    </Card>
  );
}
